module.exports = __webpack_public_path__ + "img/memorabilia.cf74ce8a.png";